let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9pMAx")).then(() => parcelRequire('237A9'));